export const REGEXP_FIRST = /^[a-hA-H]/;
export const REGEXP_SECOND = /^[i-qI-Q]/;
export const REGEXP_THIRD = /^[r-zR-Z]/;
